import Vue from 'vue'
import SvgIcon from '@/components/svgIcon'// svg component

Vue.component('svg-icon', SvgIcon)

// const req = require.context('./svg', false, /\.svg$/)
// const requireAll = requireContext => requireContext.keys().map(requireContext)
// requireAll(req)
const requireContext = require.context('./svg', false, /\.svg$/)
requireContext.keys().forEach(requireContext)
